<div class="m-3 gap-2 d-flex flex-column justify-content-between">
  @if (createForm) {
    <div class="text-black">
      <div class="pb-2">
        <app-text-field
          label="{{ 'name_field' | translate }}"
          [formControl]="createForm.controls.title"
          [error]="createForm.controls['title'].status === 'INVALID' && createForm.controls['title'].touched"
        ></app-text-field>
        @if (
          createForm.controls['title'].status === 'INVALID' &&
          (createForm.controls['title'].dirty || createForm.controls['title'].touched)
        ) {
          <mat-hint class="text-danger" style="font-size: 12px"> {{ 'field_cannot_be_empty' | translate }}. </mat-hint>
        }
      </div>
      <div>
        <app-text-field
          [label]="'key_field' | translate"
          [disabled]="field"
          [formControl]="createForm.controls.key"
          [error]="createForm.controls['key'].status === 'INVALID' && createForm.controls['key'].touched"
        ></app-text-field>
        @if (
          createForm.controls['key'].status === 'INVALID' &&
          createForm.controls['key'].touched &&
          !createForm.controls['key'].value
        ) {
          <mat-hint class="text-danger" style="font-size: 12px"> {{ 'field_cannot_be_empty' | translate }}. </mat-hint>
        }
        @if (
          createForm.controls['key'].status === 'INVALID' &&
          createForm.controls['key'].touched &&
          createForm.controls['key'].value
        ) {
          <mat-hint class="text-danger" style="font-size: 12px">
            {{ 'this_field_must_be_unique' | translate }}.
          </mat-hint>
        }
      </div>
      <div>
        <app-dropdown
          [label]="'type_field' | translate"
          [disabled]="field"
          [items]="list"
          [closeOnSelect]="true"
          [formControl]="createForm.controls.type"
        ></app-dropdown>
        <span class="text-secondary" style="font-size: 12px">{{ 'type_tooltip' | translate }}</span>
      </div>
      @if (!createForm.controls.type.value?.is_view_disabled) {
        <app-checkbox [formControl]="createForm.controls.is_view_card" class="checkbox">
          {{ 'display_in_quick_trades' | translate }}
        </app-checkbox>
      }
    </div>
  }

  <div>
    <div class="d-flex justify-content-end">
      <app-button (onChangeClick)="onCancelClick()" btnType="stroked" class="pe-4">{{
        'cancel' | translate
      }}</app-button>
      @if (!field) {
        <app-button (onChangeClick)="createField()">{{ 'add' | translate }}</app-button>
      }
      @if (field) {
        <app-button (onChangeClick)="updateField()" [disabled]="!hasChanged || createForm.invalid">{{
          'save' | translate
        }}</app-button>
      }
    </div>
  </div>
</div>
